// extracted by mini-css-extract-plugin
export default {"layoutBase":"NoBound__layoutBase--Pd+Zm"};